/**
 * Landing pane behind the Email Outreach sidebar group. Same card layout as
 * AI Tools; only the lilac theme and the tools in this group differ.
 */

import React from 'react';
import { StudioOverview } from './AiStudioOverview';

const EMAIL_OUTREACH_TOOLS = [
  {
    id: 'emailSetup',
    tab: 'email',
    kicker: 'Accounts, Footer, Warmup',
    name: 'Email Setup',
    description:
      'Connect the inboxes you send from, set a footer that travels with every mail, and warm new addresses before volume goes up.',
    icon: 'fa-inbox',
    image: '/img/setti_2.webp',
  },
  {
    id: 'templates',
    tab: 'topics',
    kicker: 'Your Voice, Ready to Send',
    name: 'Templates',
    description:
      'Write the campaigns once and train a CopyTwin on your tone, so every outgoing mail already sounds like you.',
    icon: 'fa-file-lines',
    image: '/img/docu_sales.webp',
  },
  {
    id: 'automaticReply',
    tab: 'agents',
    kicker: 'Prepared Replies for Every Email You Receive',
    name: 'Inbox Auto-Reply',
    description:
      'Describe the cases that keep coming back. The agent spots them in the inbox and drafts the answer in your tone of voice.',
    icon: 'fa-comments',
    image: '/img/fliescher_lilac.webp',
  },
];

const EmailOutreachOverview = ({ onOpenTab }) => (
  <StudioOverview
    tools={EMAIL_OUTREACH_TOOLS}
    onOpenTab={onOpenTab}
    theme="lilac"
    badge="MAIL"
  />
);

export default EmailOutreachOverview;
